import { OfferOption } from '../../models/dto/offer-option/offer-option.model';

export class GetOfferOptions {
	static readonly type = '[OfferOption] GetOfferOptions';
	constructor(public borrowerId: number) {}
}

export class CreateOfferOption {
	static readonly type = '[OfferOption] CreateOfferOption';
	constructor(public dealId: number, public offerOptionData: object) {}
}

export class UpdateOfferOptionTerms {
	static readonly type = '[OfferOption] UpdateOfferOptionTerms';
	constructor(public dealId: number, public offerOptionId: number, public termSetData: object) {}
}

export class DeleteOfferOption {
	static readonly type = '[OfferOption] DeleteOfferOption';
	constructor(public dealId: number, public offerOptionId: number) {}
}

export class PatchOfferOptionStatus {
	static readonly type = '[OfferOption] PatchOfferOptionStatus';
	constructor(public dealId: number, public offerOptionId: number, public status: string, public waitOnResponse = false) {}
}

export class BuildOfferOptionsRelationships {
	static readonly type = '[OfferOption] BuildOfferOptionsRelationships';
	constructor(public borrowerId: number) {}
}
